import React, { useEffect, useState } from 'react'
import {
    findMemberByPfNumber,
    uploadMemberProfilePictures,
} from '../../../api/apiServices';
import toast, { Toaster } from 'react-hot-toast'
import "react-phone-input-2/lib/bootstrap.css";
import { Link, useNavigate, useLocation } from "react-router-dom";

const UpdateProfilePictuire = ({ member }) => {

    const navigate = useNavigate();
        const location = useLocation();
        const from = location.state?.from?.pathname || "/view_profile";

    const [data, setData] = useState({
		pf_number: "",
		fullname: "",
		mobile_number: "",
		email: "",
        date_joined:"",
        region:"",
        constituency:"",
        profession:""
	});


	useEffect(() => {
		member?.pfNumber &&
			findMemberByPfNumber(member?.pfNumber).then((res) => {
				setData((prevData) => ({
					...prevData,
					pf_number: res.member?.pf_number,
					fullname:
						res.member?.first_name +
						" " +
						res.member?.middle_name +
						" " +
						res.member?.last_name,
					mobile_number: res.member?.mobile_number,
					region: res.member?.region,
					constituency: res.member?.constituency,
					email: res.member?.email,
					date_of_birth: res.member?.date_of_birth,
					profession: res.member?.profession,
					date_joined: res.member?.date_joined,
				}));
			});
	}, [member?.pfNumber]);

    const [memberFound, setMemberFound] = useState(false);
    const [file, setFile] = useState();

    const handleChange = (e) => {
        setFile(e.target.files[0]);
    };

    const handleProfilePictures = (e) => {
        e.preventDefault();
        const formData = new FormData();
        formData.append('file', file);
        formData.set('pf_number', data?.pf_number);
        formData.set('mobile_number', data?.mobile_number);

        uploadMemberProfilePictures(formData)
            .then((res) => {
                if (res.success) {
                    toast.success(res.message, {
                        duration: 5000,
                        className: "toast-message"
                    });
                    navigate(from, { replace: true });
                    // navigate(-1);
                } else {
                    toast.error(res.message, {
                        duration: 5000,
                        className: "toast-message"
                    });
                    setMemberFound(false)
                }
            })
            .catch((err) => {
                toast.error(err.message, {
                    duration: 5000,
                    className: "toast-message"
                });
                setMemberFound(false)
            });
    };

    const handleCancel = () => {
        setMemberFound(false);
        return false
    };


    return (
        <>
            <section className="content-header">
                <h1>Member Profile Picture Management</h1>
            </section>
            <Toaster toastOptions={{ position: "top-center" }} />
            <section className="content">
                <div className="box">
                    <div className="box-body">
                        <div className="panel panel-default panel-br-4">
                            <div className="panel-heading">
                            </div>
                        </div>
                            <div className="panel-body">
                                <fieldset className="col-sm-12">
                                    <fieldset className="col-sm-6">
                                        <div className="form-group row">
                                            <label className="col-sm-3 control-label" htmlFor="pf_number">
                                                <abbr aria-label="required">PF Number</abbr>
                                                <strong> </strong>
                                            </label>
                                            <div className="col-sm-9">
                                                <input
                                                    type="text"
                                                    id="pf_number"
                                                    name="pf_number"
                                                    value={data?.pf_number}
                                                    readOnly
                                                    className="form-control" />
                                            </div>
                                        </div>
                                        < div className="form-group row">
                                            <label className="col-sm-3 control-label" htmlFor="name">
                                                <abbr aria-label="required">Full Name</abbr>
                                            </label>
                                            <div className="col-sm-9">
                                                <input
                                                    type="text"
                                                    id="name"
                                                    name="name"
                                                    readOnly
                                                    value={data.fullname}
                                                    className="form-control" />
                                            </div>
                                        </div>
                                        < div className="form-group row">
                                            <label className="col-sm-3 control-label" htmlFor="joined_date">
                                                <abbr aria-label="required">Date Registered</abbr>
                                            </label>
                                            <div className="col-sm-9">
                                                <input
                                                    type="text"
                                                    id="joined_date"
                                                    name="joined_date"
                                                    readOnly
                                                    value={data?.date_joined}
                                                    className="form-control" />
                                            </div>
                                        </div>
                                        < div className="form-group row">
                                            <label className="col-sm-3 control-label" htmlFor="region">
                                                <abbr aria-label="required">Region</abbr>
                                            </label>
                                            <div className="col-sm-9">
                                                <input
                                                    type="text"
                                                    id="region"
                                                    name="region"
                                                    readOnly
                                                    value={data?.region}
                                                    className="form-control" />
                                            </div>
                                        </div>
                                    </fieldset>
                                    <fieldset className="col-sm-6">
                                        <div className="form-group row">
                                            <label className="col-sm-3 control-label" htmlFor="constituency">
                                                <abbr aria-label="required">Constituency</abbr>
                                                <strong></strong>
                                            </label>
                                            <div className="col-sm-9">
                                                <input
                                                    type="text"
                                                    id="constituency"
                                                    name="constituency"
                                                    value={data?.constituency}
                                                    readOnly
                                                    className="form-control" />
                                            </div>
                                        </div>
                                        < div className="form-group row">
                                            <label className="col-sm-3 control-label" htmlFor="profession">
                                                <abbr aria-label="required">Profession</abbr>
                                            </label>
                                            <div className="col-sm-9">
                                                <input
                                                    type="text"
                                                    id="profession"
                                                    name="profession"
                                                    readOnly
                                                    value={data?.profession}
                                                    className="form-control" />
                                            </div>
                                        </div>
                                        < div className="form-group row">
                                            <label className="col-sm-3 control-label" htmlFor="mobile_number">
                                                <abbr aria-label="required">Phone Number</abbr>
                                            </label>
                                            <div className="col-sm-9">
                                                <input
                                                    type="text"
                                                    id="mobile_number"
                                                    name="mobile_number"
                                                    readOnly
                                                    value={data?.mobile_number}
                                                    className="form-control" />
                                            </div>
                                        </div>
                                        < div className="form-group row">
                                            <label className="col-sm-3 control-label" htmlFor="email">
                                                <abbr aria-label="required">Email Address</abbr>
                                            </label>
                                            <div className="col-sm-9">
                                                <input
                                                    type="text"
                                                    id="email"
                                                    name="email"
                                                    readOnly
                                                    value={data?.email}
                                                    className="form-control" />
                                            </div>
                                        </div>
                                    </fieldset>
                                </fieldset>
                                <fieldset className="col-sm-12">
                                    <hr />
                                    < div className="form-group row">
                                        <label className="col-sm-2 control-label" htmlFor="profile_picture">
                                            <abbr aria-label="required"> Upload Profile Picture</abbr>
                                            <strong></strong>
                                        </label>
                                        <div className="col-sm-6">
                                            <input
                                                type="file"
                                                id="profile_picture"
                                                name="profile_picture"
                                                autoComplete='off'
                                                onChange={handleChange}
                                                className="form-control" />
                                        </div>
                                        <div className="col-sm-2">
                                            <button
                                                type="submit"
                                                className="btn btn-success btn-block "
                                                onClick={handleProfilePictures}
                                            > <i className="fa fa-upload"></i> Submit</button>
                                        </div>
                                        <div className="col-sm-2">
                                            <button
                                                type="submit"
                                                className="btn btn-danger btn-block "
                                                onClick={handleCancel}
                                            > <i className="fa fa-close"></i> Cancel</button>
                                        </div>
                                    </div>
                                </fieldset>
                            </div>
                    </div>
                </div>
                <div className="panel-footer"></div>
            </section >
        </>
    );
}

export default UpdateProfilePictuire